export default "__VITE_ASSET__DPnUl3YM__"